import * as React from 'react'
import { IMessageService } from '../../common/IMessageService'
import { CalculationLog } from '../../model/CalculationLog'
import { ErrorMessage } from '../../model/Message'
import './CalculationLogStyles.scss'

export interface IStateProps {
  runIdentifier: string,
  messageService: IMessageService
}

export interface IDispatchProps {
  getLogs: (
    runIdentifier: string
  ) => Promise<CalculationLog>
}

type Props = IDispatchProps & IStateProps

type State = {
  loading: boolean,
  log: CalculationLog
}

export class CalculationLogPage extends React.Component<Props, State> {
  constructor(props: Props) {
    super(props)

    this.state = {
      loading: true,
      log: new CalculationLog()
    }
  }

  timer: NodeJS.Timer | null = null

  componentDidMount(): void {
    this.fetchLogs()
    this.timer = setInterval(() => this.fetchLogs(), 1000)
  }

  componentWillUnmount(): void {
    if(this.timer) clearInterval(this.timer)
    this.timer = null
  }

  fetchLogs = (): void => {
    this.props.getLogs(this.props.runIdentifier)
      .then(result => { this.setState({ log: result, loading: false }) })
      .catch(err => {
        this.props.messageService.sendMessage(ErrorMessage('Failed to get calculation log', err))
        console.info('Failed to get calculation log')
      })
  }

  render() {
    const {
      loading,
      log
    } = this.state

    if(loading){
      return <h1>Loading...</h1>
    } else if(log.notStarted) {
      return <h1>Calculation waiting in queue...</h1>
    } else {
      return <div>
          <h1>{log.description}</h1>
          <p>Started at {log.startTime}</p>
          <p className={log.complete ? (log.success ? "completed" : "failed") : "in-progress"}>{log.complete ? (log.success ? "Completed at " : "Failed at ") + log.endTime : "In Progress..."}</p>
          <ul className="console-window">
            {log.messages.map(m => <li className={m.logType}>{m.message}</li>)}
          </ul>
        </div>
    }
  }
}